import { render, staticRenderFns } from "./PerformanceTable.vue?vue&type=template&id=217d666d&scoped=true"
import script from "./PerformanceTable.vue?vue&type=script&lang=js"
export * from "./PerformanceTable.vue?vue&type=script&lang=js"
import style0 from "./PerformanceTable.vue?vue&type=style&index=0&id=217d666d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217d666d",
  null
  
)

export default component.exports